import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import styles from './Processes.module.scss';

const Processes = ({ headers, table, button }) => {
  return (
    <BaseSection
      { ...headers }
      button={ button }
      anchor='processes'
    >
      <Table { ...table } />
    </BaseSection>
  );
};

const Table = ({ head, body }) => {
  return (
    <table className={ styles.Table }>
      { head && <TablaHeader headers={ head } /> }
      { body && (<tbody>
        { body.map(row => <TableRow key={ row.header } { ...row } />) }
      </tbody>) }
    </table>
  );
};

const TablaHeader = ({ headers }) => {
  return (
    <thead className={ styles.TablaHeader }>
      <tr>
        { headers.map(item => <td key={ item }>{ item }</td>) }
      </tr>
    </thead>
  );
};

const TableRow = ({ header = '', process, strategy }) => {
  return (
    <tr className={ styles.TableRow }>
      <td className={ styles.rowTitle }>{ header }</td>
      <TableCell content={ process } />
      <TableCell content={ strategy } />
    </tr>
  );
};

const TableCell = ({ content }) => {
  let cell = content; 
  if (Array.isArray(content)) {
    cell = <ul>{ content.map(item => <li key={ item }>{ item }</li>) }</ul>;
  }

  return <td>{ cell }</td>;
};
 
export default Processes;
